module.exports = __webpack_public_path__ + "img/logo_bg.83407e07.png";